import React from 'react'

const MachineMainContent = () => {
    return (
        <>
            <section className="services-details-area ptb-80">
                <div className="container">
                    <div className="row ">
                        <div className="col-lg-12 services-details">
                            <div className="ml-about-content">
                                {/* <h2>Machine Learning</h2> */}
                                <h1>Excellence in Machine Learning Service</h1>
                                <div className="bar" />
                                <p>
                                    Machine Learning architecture is defined as the subject that has
                                    evolved from the concept of fantasy to the proof of reality. As earlier Machine Learning Service for pattern recognitions has lead foundation for the upcoming major artificial intelligence program.
                                    Based upon the different algorithm that is used on the training data
                                    machine learning architecture is categorized into three types i.e.
                                    Supervised Learning, Unsupervised Learning, and Reinforcement
                                    Learning and the process involved in this architecture are Data
                                    Aquisition, Data Processing, Model Engineering, Excursion, and
                                    Deployment.
                                </p>
                            </div>
                        </div>
                        {/* <div class="col-lg-6 services-details-image">
					<img src="assets/img/service-detail-image/ml.webp" class="wow fadeInUp" alt="">
				</div> */}
                    </div>
                    <div className="separate" />
                    <div className="row ">
                        <div className="col-lg-6 services-details-image">
                            <img
                                src="assets/img/service-detail-image/ml-2.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                            <img
                                src="assets/img/service-detail-image/ml.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                        </div>
                        <div className="col-lg-6 services-details">
                            <div className="services-details-desc">
                                <p>
                                    The machine learning model workflow generally follows this sequence:
                                </p>
                                <div className="services-details-accordion">
                                    <ul className="accordion">
                                        <li className="accordion-item">
                                            <a className="accordion-title p-3" href="javascript:void(0)">
                                                {/* <i class="flaticon-plus"></i> */} <strong>Package</strong>
                                                <ul>
                                                    <li>
                                                        Develop machine learning training scripts in Python or
                                                        with the visual designer.
                                                    </li>
                                                    <li>Create and configure a compute target.</li>
                                                    <li>
                                                        Submit the scripts to the configured compute target to run
                                                        in that environment. During training, the scripts can read
                                                        from or write to datastore. And the records of execution
                                                        are saved as runs in the workspace and grouped under
                                                        experiments.
                                                    </li>
                                                </ul>
                                            </a>
                                            {/* <div class="accordion-content">
										<ul>
											<li>Develop machine learning training scripts in Python or with the visual designer.</li>
											<li>Create and configure a compute target.</li>
											<li>Submit the scripts to the configured compute target to run in that environment. During training, the scripts can read from or write to datastore. And the records of execution are saved as runs in the workspace and grouped under experiments.</li>
										</ul>
										</div> */}
                                        </li>
                                        <li className="accordion-item">
                                            <a className="accordion-title p-3" href="javascript:void(0)">
                                                {/* <i class="flaticon-plus"></i> */} <strong>Package</strong>{" "}
                                                - After a satisfactory run is found, register the persisted
                                                model in the model registry.
                                            </a>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                        <li className="accordion-item">
                                            <a className="accordion-title p-3" href="javascript:void(0)">
                                                {/* <i class="flaticon-plus"></i> */}{" "}
                                                <strong>Validate</strong> - Query the experiment for logged
                                                metrics from the current and past runs. If the metrics don't
                                                indicate a desired outcome, loop back to step 1 and iterate on
                                                your scripts.
                                            </a>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                        <li className="accordion-item">
                                            <a className="accordion-title p-3" href="javascript:void(0)">
                                                {/* <i class="flaticon-plus"></i> */} <strong>Deploy</strong>{" "}
                                                - Develop a scoring script that uses the model and Deploy the
                                                model as a web service in Azure, or to an IoT Edge device.
                                            </a>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                        <li className="accordion-item">
                                            <a className="accordion-title p-3" href="javascript:void(0)">
                                                {/* <i class="flaticon-plus"></i> */} <strong>Monitor</strong>{" "}
                                                - Monitor for data drift between the training dataset and
                                                inference data of a deployed model. When necessary, loop back
                                                to step 1 to retrain the model with new training data.
                                            </a>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="separate" />
                    <div className="row ">
                        <div className="col-lg-6 services-details">
                            <div className="services-details-desc">
                                {/* <h3>
                                    <b>Transfer your business on Machine Learning Tools</b>
                                </h3> */}
                                <h2 style={{ fontSize: "20px", marginBottom: "15px", fontFamily: "Montserrat" }}>
                                    <b>Transfer your business on Machine Learning Model</b>
                                </h2>
                                <p>
                                    We are leaders in Machine Learning services in India. This is the
                                    technically evolved tool in marketing that is on-trend. We at Alobha
                                    Technologies, identify the Machine Learning services as one of the
                                    peak problem-solving techniques for developing and established
                                    businesses in minimum time. Researching upon the different algorithm
                                    that is used on the training data machine learning architecture is
                                    categorized into three types i.e. Supervised Learning, Unsupervised
                                    Learning, and Reinforcement Learning and the process involved in
                                    this architecture are Data Acquisition, Data Processing, Model
                                    Engineering, Excursion, and Deployment. Machine learning is a very
                                    vast concept in this artificial intelligence world. Do you know what
                                    is it?
                                </p>
                                {/* <h3>
                                    <b>What is Machine Learning?</b>
                                </h3> */}
                                <h2 style={{ fontSize: "20px", marginBottom: "15px", fontFamily: "Montserrat" }}>
                                    <b>What is Machine Learning?</b>
                                </h2>
                                <p>
                                    Machine Learning (ML) is the idea that helps machines to learn from
                                    data. This is one of the latest techniques of the technological era.
                                    It is done by finding the pattern from the long lists of data. Thus,
                                    the presentation of the resolution will depend on the data that is
                                    being fed to the models. It changes and builds procedures that allow
                                    processors to learn how to execute tasks from existing data. This
                                    function completely reduces the workload of a programmer and gives
                                    him time to work on the rest of the main tasks.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details mb-2">
                            <div className="services-details-desc">
                                {/* <h3>
                                    <b>Machine Learning Integration</b>
                                </h3> */}
                                <h2 style={{ fontSize: "20px", marginBottom: "15px", fontFamily: "Montserrat" }}>
                                    <b>Machine Learning Solution</b>
                                </h2>
                                <p>
                                    Machine Learning solutions are used to excerpt unused value from a
                                    vast amount of data. This helps in increasing the productivity of a
                                    business by order of scale. Machine learning supports the company in
                                    hurries its growth by powering numerous complex tasks and offering
                                    highly pioneering and technology-based tools to the organizations.
                                </p>
                                <p>
                                    <b>Improve your solution:</b> Our qualified team helps clients to
                                    retool an existing system to expand functions of the frontend
                                    applications.
                                </p>
                                <p>
                                    <b>Media workflow automation:</b> Machine Learning powers complex
                                    tasks and its optimization highlights the decision-making process of
                                    concerns.
                                </p>
                                <p>
                                    <b>Computer vision systems:</b> Machine Learning applications offer
                                    quality software like monetizing the visual content, managing up the
                                    visual data, and offer Artificial Intelligent functionality.
                                </p>
                                <p>
                                    <b>Video Processing Tool:</b> Our developers do deep learning for
                                    superior video quality by using top premium tools to build quality
                                    video content.
                                </p>
                                <p>
                                    <b>Shopping Experience:</b> Through AI Machine Learning, we provide
                                    you real-time customer’s marketing to extend their engagement,
                                    generate audience loyalty, and boost your sales.
                                </p>
                                <p>
                                    <b>Improved Outcome Predictions:</b> We Identify unique behavioural
                                    patterns in the audience and even predict demand of products, hence
                                    you will plan stocks efficiently.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-12 services-details">
                            <div className="services-details-desc">
                                {/* <h3>
                                    <b>
                                        Enhance Your Customer Skill with our Machine Learning Development
                                        Service
                                    </b>
                                </h3> */}
                                <h2 style={{ fontSize: "20px", marginBottom: "15px", fontFamily: "Montserrat" }}>
                                    <b>Enhance Your Customer Skill with our Machine Learning Development Service</b>
                                </h2>
                                <p>
                                    We provide the best Machine learning website development in India
                                    that possibly the best machine learning solutions for your business.
                                    Our skilled machine learning development team has strong experience
                                    in producing, managing, creating, and offering excellent machine
                                    learning services for all clients. Just share your requirements as
                                    per your business needs. Our engineers focus on the proper
                                    development phase for a better understanding of the solution.
                                    Complete care of projects is provided by us from the very first day.
                                    We Speed-up the execution process which helps the organization and
                                    saves time too.
                                </p>
                                <h3>
                                    <b>How we work for you</b>
                                </h3>
                                <ul className="text_color">
                                    <li>
                                        In development phase we analyze your requirements and set a goal.
                                    </li>
                                    <li>Examine all information which is provided by clients.</li>
                                    <li>Set a working route</li>
                                    <li>Perform model prototyping and implementation.</li>
                                    <li>Testing and verifying all results.</li>
                                    <li>deploying a tailored custom system.</li>
                                </ul>
                                <h3>
                                    <b>Choose us for Machine Learning Project</b>
                                </h3>
                                <p>
                                    Being a reliable and one of the top machine learning development
                                    companies in Noida, India, Alobha proffers the state-of-the-art
                                    machine learning and data science services statistic work to make
                                    your machine more innovative in this technical century. So are you
                                    ready to work with us?
                                </p>
                            </div>
                        </div>
                    </div>
                    <br />
                    <br />
                </div>
            </section>

        </>
    )
}

export default MachineMainContent